import { useCallback, useRef } from "react";

export const shouldShowFormError = (
  fieldTouched,
  fieldError,
  submitAttempted,
) => (fieldTouched || submitAttempted) && fieldError;

export const copyTextToClipboard = async (text) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "absolute";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    try {
      ta.select();
      return document.execCommand("copy");
    } finally {
      ta.remove();
    }
  } catch {
    return false;
  }
};

export const useDebouncedCallback = (callback, delayMs) => {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef(null);
  callbackRef.current = callback;

  const debouncedCallback = useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        callbackRef.current(...args);
      }, delayMs);
    },
    [delayMs],
  );

  const cancel = useCallback(() => {
    if (!timeoutRef.current) return;
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }, []);

  debouncedCallback.cancel = cancel;
  return debouncedCallback;
};